import React, { useEffect, useState } from 'react'
import Spasoft from '../images/logo.png'
import { GiHamburgerMenu } from "react-icons/gi";
import { MdAccountCircle } from "react-icons/md";
import NavDropdown from 'react-bootstrap/NavDropdown';
import './Navbar.css'
import Hamburger from './Hamburger';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';

const Secondnavbar = () => {
  const selector = useSelector(state => state)
    const [adminname, setadminname] = useState(null);
    const[show,setshow]=useState(false)
    const handleshow=()=>{
        setshow(true)
    }
    const handleoff=()=>{
        setshow(false)
    }
    useEffect(() => {
      if (selector.details.data != null) {
        const managername = selector.details.data[""][0].manager_name
        setadminname(managername)
      }
    }, [selector])

    const handlelogout = () => {
      sessionStorage.removeItem('Apipathurl')
      window.location.href = "https://blogbuster.hexbss.xyz/login"
    }
  return (
    <div className="container-fluid nav-top">
    <div className="row">
        <div className="col-12">
           <div className='dis-play'>
            <div className='d-flex'>
            <div>
                    <GiHamburgerMenu onClick={handleshow} className='fs-2'/>
                    <Hamburger show={show} handleoff={handleoff}/>
                    </div>
           <div>
            <img src={Spasoft} alt="" />
            </div>
                </div>

            <div className='sec-dis'>
              <div className='dis-play'>
               <div className='dis-icon'>
               <p><MdAccountCircle className='icon-size-2'/></p>
                <NavDropdown title={adminname != null ? adminname : "Admin Account"} id="navbarScrollingDropdown">
              <NavDropdown.Item >  <Link to="profile" className='text-black' style={{ marginLeft: "16px" }}>  My Profile</Link></NavDropdown.Item>
              <NavDropdown.Divider />
              <NavDropdown.Item  onClick={handlelogout}>
               logout
              </NavDropdown.Item>
            </NavDropdown>
               </div>
                </div>
    </div>
    </div>
    </div>
    </div>
  </div>
  )
}

export default Secondnavbar